import React from "react";
import { useTranslation } from "react-i18next";
import { Button, EmptySlate } from "@activecollab/components";
import PropTypes from "prop-types";
import Angie from "~/utils/angie";

const ExternalEmptySlate = ({ isLoggedIn, onLogout }) => {
  const { t } = useTranslation();
  return (
    <EmptySlate
      title={isLoggedIn ? t("You Are Already Logged In") : t("Page Not Found")}
      className="tw-h-full tw-mt-20"
      description={
        isLoggedIn
          ? t("Please log out if you want to use a different account.")
          : t("This is not the page you are looking for.")
      }
      src={`${Angie.assets_url}/system/images/layout/404.png`}
      alt="Not Found"
    >
      {isLoggedIn ? (
        <Button
          className="tw-mt-6"
          onClick={onLogout}
        >
          {t("Logout")}
        </Button>
      ) : null}
    </EmptySlate>
  );
};

ExternalEmptySlate.propTypes = {
  isLoggedIn: PropTypes.bool,
  onLogout: PropTypes.func,
};

export default ExternalEmptySlate;
